import { Box, Text } from "@chakra-ui/react";
import TourLayout from "../Layout/TourLayout";

export default function DatasourcesTour({ onCloseDatasourcesTour }) {
  return (
    <TourLayout onCloseTour={onCloseDatasourcesTour}>
      <Box fontSize={"md"}>
        <Text fontSize={"md"}>
          A Data Source (DS) is a collection of Data Source Files (DSF). Each
          DSF represents a single unit of your knowledge base and is used by the
          AI Assistants to answer a particular query. We support HTTP (any
          website/domain), PDF, text Blob, CSV.
        </Text>
      </Box>
    </TourLayout>
  );
}
